import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import React, { ReactNode } from 'react';

interface MbwSettingAccordionProps {
  title: string;
  children?: ReactNode;
}
const MbwSettingAccordion = ({ title, children }: MbwSettingAccordionProps) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />} id={`accordion-${title}`}>
        {title}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default MbwSettingAccordion;
